document.addEventListener("DOMContentLoaded", () => {
  const boxes = document.querySelectorAll<HTMLDivElement>(".animated-grid-expanding-fact-box");
  const isTouchDevice = window.matchMedia("(hover: none)").matches; // Detects if device supports touch

  boxes.forEach((box) => {
    const hoverText = box.querySelector<HTMLDivElement>(".hover-text");
    const parentSlide = box.closest<HTMLElement>(".swiper-slide");

    if (!hoverText) return;

    // Function to expand box
    const expandBox = () => {
      box.classList.add("expanded");
      box.classList.add("hovered"); // Adds the hover effect via class
      hoverText.style.visibility = "visible";
      box.style.height = `${box.scrollHeight}px`;
      if (parentSlide) parentSlide.style.height = `${box.scrollHeight}px`;
      document.dispatchEvent(new CustomEvent("updateSwiperHeight"));
    };

    // Function to collapse box
    const collapseBox = () => {
      box.classList.remove("expanded");
      box.classList.remove("hovered");
      hoverText.style.visibility = "hidden";
      box.style.height = "100%";
      if (parentSlide) parentSlide.style.height = `${box.dataset.originalHeight}px`;
      document.dispatchEvent(new CustomEvent("updateSwiperHeight"));
    };

    if (!isTouchDevice) {
      // **Desktop: Use mouse hover**
      box.addEventListener("mouseenter", expandBox);
      box.addEventListener("mouseleave", collapseBox);
    } else {
      // **Touch devices: Tap to expand/collapse**
      let isDragging = false;
      let startX = 0;
      let startY = 0;
      const dragThreshold = 10;

      box.addEventListener("touchstart", (event) => {
        isDragging = false;
        const touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        if (!box.dataset.originalHeight) {
          box.dataset.originalHeight = `${box.offsetHeight}`;
        }
      });

      box.addEventListener("touchmove", (event) => {
        const touch = event.touches[0];
        if (Math.abs(touch.clientX - startX) > dragThreshold || Math.abs(touch.clientY - startY) > dragThreshold) {
          isDragging = true;
        }
      });

      box.addEventListener("touchend", () => {
        if (!isDragging && event) {
          const target = event.target as HTMLElement | null;

          // Prevent toggle if clicking inside an <a> tag
          if (target && target.closest("a")) return;

          if (box.classList.contains("expanded")) {
            collapseBox();
          } else {
            expandBox();
          }
        }
      });
    }
  });

  // Adjust box heights on resize
  window.addEventListener("resize", () => {
    boxes.forEach((box) => {
      box.style.height = "100%";
    });
  });
});
